import { useMutation } from '@apollo/client/react';
import Box from '@mui/material/Box';
import { useParams } from 'react-router';

import { AppBar } from 'common/components/AppBar';
import { ContentContainer } from 'common/components/ContentContainer';
import { LtiDeepLinkTabsMenu } from 'connections/components/LtiDeepLinkTabsMenu';
import { LtiDeepLinkTrainings } from 'connections/components/LtiDeepLinkTrainings';
import {
    ICourseListItemFragment,
    ITrainingListItemFragment,
    LtiDeepLinkResponseDocument,
} from 'graphql/types';
import { useRouteMatch } from 'route/hooks/useRouteMatch';
import { LtiDeepLinkCourses } from 'connections/components/LtiDeepLinkCourses';
import { useApolloError } from 'common/hooks/useApolloError';

export const LtiDeepLinkPage = () => {
    const { launchId } = useParams();
    const [LtiDeepLink, { loading: loadingDeeplinkResponse }] = useMutation(
        LtiDeepLinkResponseDocument
    );
    const trainings = !!useRouteMatch('CONNECTIONS_LTI_TRAININGS');
    const { showApolloError } = useApolloError();

    if (!launchId) return null;

    const handleLTIDeepLink = async (
        selectedTrainings?: ITrainingListItemFragment[],
        selectedCourses?: ICourseListItemFragment[]
    ) => {
        if (!selectedTrainings && !selectedCourses) return;

        let response;

        try {
            response = await LtiDeepLink({
                variables: {
                    launchId,
                    trainingIds:
                        selectedTrainings?.map((training) => training.id) || [],
                    courseIds:
                        selectedCourses?.map((course) => course.id) || [],
                },
            });
        } catch (error) {
            showApolloError(error);
        }

        const { returnUrl, token } =
            response?.data?.lti1p3DeepLinkResponse || {};

        if (!returnUrl || !token) return;

        // Create form with JWT input and add it to the body to be able to submit
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = returnUrl;

        const jwtInput = document.createElement('input');
        jwtInput.setAttribute('name', 'JWT');
        jwtInput.setAttribute('value', token);

        form.appendChild(jwtInput);
        document.body.appendChild(form);

        form.submit();
    };

    return (
        <>
            <AppBar showNavigation={false} />
            <ContentContainer maxWidth="md">
                <Box sx={{ py: { xs: 4, sm: 8 } }}>
                    <LtiDeepLinkTabsMenu />

                    {trainings && (
                        <LtiDeepLinkTrainings
                            launchId={launchId}
                            loadingDeeplink={loadingDeeplinkResponse}
                            onSelectTrainings={(
                                selectedTrainings: ITrainingListItemFragment[]
                            ) => handleLTIDeepLink(selectedTrainings)}
                        />
                    )}

                    {!trainings && (
                        <LtiDeepLinkCourses
                            launchId={launchId}
                            loadingDeeplink={loadingDeeplinkResponse}
                            onSelectCourses={(
                                selectedCourses: ICourseListItemFragment[]
                            ) => handleLTIDeepLink(undefined, selectedCourses)}
                        />
                    )}
                </Box>
            </ContentContainer>
        </>
    );
};
